'use client';

import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from '@/shared/modules/styled-system';
import * as Styled from './skeleton-profile.styled';

/**
 * @useClient
 */
export const SkeletonProfile = React.memo(function SkeletonProfile() {
  return <ThemeProvider theme={lightTheme}>
      <Styled.Container>
        <Styled.Cover />
        <Styled.UserInfo>
          <Styled.Avatar />
          <Styled.Username />
        </Styled.UserInfo>
        <Styled.Content>
          <Styled.Tabs />
          <Styled.Grid>
            <Styled.Col />
            <Styled.Col />
          </Styled.Grid>
        </Styled.Content>
      </Styled.Container>
    </ThemeProvider>;
});